export const userRoles = {
  Employer: 'employer',
  Vendor: 'vendor',
  All: 'ALL'
}
